export default class Expert{
  // @ts-ignore
  constructor(data) {
    this.id = data.id
    this.name = data.name
    this.pic = data.pic
    this.position = data.position
    this.sort = data.sort
    this.title = data.title
    this.fields = data.fields
    this.description = data.description
    return this
  }
}
